import type { Music24PlanTier } from 'fym-shared/src/music24/music24Plans';
import { useVideoCredits } from '../credits/useVideoCredits';

export interface StudioPlan {
  /** The plan makes full-song videos. Undefined while the credits load: the cards stay open. */
  canRenderFullSongVideos: boolean | undefined;
  /** Only the owner of the workspace upgrades (D11). */
  isOwner: boolean;
  /** The plan of the workspace. Undefined while the credits load. */
  plan: Music24PlanTier | undefined;
}

/**
 * The plan facts of the Studio (design s7c), read from the credits answer (`GET .../credits`, the
 * same read as the video-credit box): full videos on the plan, the owner of the workspace, and the
 * plan.
 */
export function useStudioPlan(accountId: number): StudioPlan {
  const { credits } = useVideoCredits({ accountId });
  return {
    canRenderFullSongVideos: credits?.canRenderFullSongVideos,
    isOwner: credits?.isOwner ?? false,
    plan: credits?.plan,
  };
}
